import React from 'react';
import styled from 'styled-components';
import { getPublicAsset } from 'base/shared/Utils';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 2rem;
  }
`;

const MainTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.125rem;
  color: #6b7280;
  text-align: center;
  margin-bottom: 2rem;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 262px);
  gap: 2rem;
  justify-content: center;

  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 262px);
  }
`;

const FeatureCard = styled.div`
  background: transparent;
  width: 262px;
`;

const ImageContainer = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
  width: 262px;
  height: 345px;
  background-image: url('${(props) => props.$imageUrl}');
  background-size: cover;
  background-position: center;
  border-radius: 1rem;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.7) 100%);
    border-radius: 1rem;
  }
`;

const OverlayText = styled.h3`
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.2;
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  z-index: 1;
  max-width: 200px;
`;

const DescriptionContainer = styled.div`
  text-align: center;
  padding: 0 0.5rem;
  width: 262px;
`;

const Description = styled.p`
  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.6;

  strong {
    color: #111827;
    font-weight: 600;
  }
`;

export default function FeaturedSection() {
  return (
    <Container>
      <MainTitle>{translate('v2.home.featuredSection.title')}</MainTitle>
      <Subtitle>{translate('v2.home.featuredSection.subtitle')}</Subtitle>

      <FeaturesGrid>
        {/* Beautiful rooms card */}
        <FeatureCard>
          <ImageContainer $imageUrl={getPublicAsset('v2/images/featured-1.png')}>
            <OverlayText>{translate('v2.home.featuredSection.card1.title')}</OverlayText>
          </ImageContainer>
          <DescriptionContainer>
            <Description
              dangerouslySetInnerHTML={{ __html: translate('v2.home.featuredSection.card1.desc') }}
            />
          </DescriptionContainer>
        </FeatureCard>

        {/* Living made effortless card */}
        <FeatureCard>
          <ImageContainer $imageUrl={getPublicAsset('v2/images/featured-2.png')}>
            <OverlayText>{translate('v2.home.featuredSection.card2.title')}</OverlayText>
          </ImageContainer>
          <DescriptionContainer>
            <Description
              dangerouslySetInnerHTML={{ __html: translate('v2.home.featuredSection.card2.desc') }}
            />
          </DescriptionContainer>
        </FeatureCard>

        {/* Booking process card */}
        <FeatureCard>
          <ImageContainer $imageUrl={getPublicAsset('v2/images/featured-3.png')}>
            <OverlayText>{translate('v2.home.featuredSection.card3.title')}</OverlayText>
          </ImageContainer>
          <DescriptionContainer>
            <Description
              dangerouslySetInnerHTML={{ __html: translate('v2.home.featuredSection.card3.desc') }}
            />
          </DescriptionContainer>
        </FeatureCard>

        {/* Contract flexibility card */}
        <FeatureCard>
          <ImageContainer $imageUrl={getPublicAsset('v2/images/featured-4.png')}>
            <OverlayText>{translate('v2.home.featuredSection.card4.title')}</OverlayText>
          </ImageContainer>
          <DescriptionContainer>
            <Description
              dangerouslySetInnerHTML={{ __html: translate('v2.home.featuredSection.card4.desc') }}
            />
          </DescriptionContainer>
        </FeatureCard>
      </FeaturesGrid>
    </Container>
  );
}
